<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from 'src/helpers/home_helpers';

	const updateHomeData = () => {
		save_home('premiumWeatherWidgetAdvertise', {
			seen: false,
		});

		home_data.set({
			...$home_data,
			premiumWeatherWidgetAdvertise: {
				seen: false,
			},
		});
	};
</script>

<IconButton icon="fas fa-gem" on:click={updateHomeData}>Reset Premium Weather Widget Ads</IconButton>
